import React, { useRef, useEffect, useState } from 'react';
import canvasSizes from './util/canvasSizes';
import drawGradientEffect from './util/drawGradientEffect';

// TODO: need to wait before color effect is rendered?
function renderColorEffect(canvas, wd, hg) {
  canvas.className = 'off';

  // start transition animation
  setTimeout(() => {
    drawGradientEffect(canvas, wd, hg);
    canvas.className = canvas.className === 'off' ? 'on' : 'hard';
  }, 600);
}

const CanvasEffect = () => {
  const canvasRef = useRef(null);
  const [enabled, setEnabled] = useState(false);

  // set the canvas to full size when loaded & resized
  const { width, height } = canvasSizes(canvasRef ? canvasRef.current : null);

  useEffect(() => {
    let i = 0;
    const canvas = canvasRef.current;
    // animationFrames are faster than React Hooks, so keep local setting coupled with isEnabled
    let initialFrameRendered = enabled;

    let animationFrameId = requestAnimationFrame(renderFrame);

    function renderFrame() {
      animationFrameId = requestAnimationFrame(renderFrame);
      i++;

      if (!enabled && !initialFrameRendered) {
        // render initial frame when all is ready
        initialFrameRendered = true;
        setEnabled(true);
      }

      if (i % 500 === 0 || i === 10) {
        renderColorEffect(canvas, width, height);
      }
    }

    return () => cancelAnimationFrame(animationFrameId);
  });

  return (
    <>
      <canvas ref={canvasRef} />
    </>
  );
};

CanvasEffect.defaultProps = {};

CanvasEffect.propTypes = {};

export default CanvasEffect;
